/**
 * 裁剪 dev-info 后得到的相关配置
 */
import type { IMonoInjectedDevInfo } from 'hel-mono-types';

export const DEV_INFO: IMonoInjectedDevInfo = {
  mods: {
    '@hel-demo/mono-libs': {
      port: 3101,
      groupName: '@hel-demo/mono-libs',
      names: {},
    },
  },
  devHostname: 'http://localhost',
};
